import { Checkbox } from "components/Atoms/inputs/Checkbox";
import CardRowSegment from "components/CardRowSegment/CardRowSegment";
import { useQuery } from "@tanstack/react-query";
import React from "react";
import Modal from "components/modal";
import { Loading } from "components/panels";
import { Button } from "semantic-ui-react";
import { getTranslation } from "utilities/articleUtils";
import { SomethingUnexpectedHappenedMessageBox } from "components/MessageBox/SomethingUnexpectedHappenedMessageBox";

interface Props {
  hasAgreedWithTerms: boolean;
  setHasAgreedWithTerms: (value: boolean) => void;
  hasError: boolean;
  setHasError: (value: boolean) => void;
}

export const TermsAndConditions = (props: Props) => {
  const { hasAgreedWithTerms, setHasAgreedWithTerms, hasError, setHasError } = props;

  const [isShowingTerms, setIsShowingTerms] = React.useState(false);
  const termsArticleId = serverReference.constants.article.endUserLicenceTerms;
  const supportApi = useQuery({
    queryKey: ["support", termsArticleId],
    queryFn: () => window.CoreApi.Article.GetArticle(termsArticleId).then(r => r.data.data),
  });

  return <CardRowSegment>
    <CardRowSegment.Header>
      Terms and conditions
    </CardRowSegment.Header>
    <div className="margin-top flex">
      <div className="margin-right-small">
        <Checkbox
          error={hasError}
          label={<span>I accept the&nbsp;
            <a className={hasError ? "red" : undefined} onClick={(e) => {
              setIsShowingTerms(true);
              e.preventDefault();
              e.stopPropagation();
            }}>
              Terms and Conditions
            </a>
          </span>}
          checked={hasAgreedWithTerms}
          onChange={(_, checked) => {
            setHasAgreedWithTerms(checked);
            setHasError(false);
          }}
        />
      </div>
    </div>

    <Modal
      isOpen={isShowingTerms}
      handleClose={() => { setIsShowingTerms(false); }}
      title="Terms and Conditions"
      height={700}
      size="large"
    >
      {supportApi.isLoading && <Loading />}
      {supportApi.data != null && <div className="scrollbox-auto terms-conditions" dangerouslySetInnerHTML={{ __html: getTranslation(supportApi.data.translations).content }} >
      </div>}
      {supportApi.isError && <SomethingUnexpectedHappenedMessageBox />}

      <div className="margin-top-large flex">
        <div className="grow1"></div>
        <Button primary onClick={() => { setIsShowingTerms(false); }}>
          {RESX.Buttons.BtnOk}
        </Button>
      </div>
    </Modal>
  </CardRowSegment>
}
